import { AxiosResponse } from "axios";

import {
  IAddEditStaffRequest,
  IAddEditStaffResponse,
  IGetStaffResponse,
  IHospitalStaffResponse,
  ITaggableHcp,
} from "../@types/Staff";
import { api } from "./api";

export const staffService = {
  async getHospitalStaff(): Promise<AxiosResponse<IHospitalStaffResponse[]>> {
    const url = "/Portal/Staff/GetHospitalStaff";

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getHospitalStaffById(
    staffId: number
  ): Promise<AxiosResponse<IGetStaffResponse>> {
    const url = `/Portal/Staff/GetStaffById/${staffId}`;

    const serverResponse = await api.get(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async addHospitlStaff(
    staffData: IAddEditStaffRequest
  ): Promise<AxiosResponse<IAddEditStaffResponse>> {
    const url = `/Portal/Staff`;

    const serverResponse = await api.post(url, staffData);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async editHospitlStaff(
    staffId: number,
    staffData: IAddEditStaffRequest
  ): Promise<AxiosResponse<IAddEditStaffResponse>> {
    const url = `/Portal/Staff/${staffId}`;

    const serverResponse = await api.put(url, staffData);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async archiveHospitlStaff(staffId: number): Promise<AxiosResponse<boolean>> {
    const url = `/Portal/Staff/Archive/${staffId}`;

    const serverResponse = await api.put(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async reactivateHospitlStaff(
    staffId: number
  ): Promise<AxiosResponse<boolean>> {
    const url = `/Portal/Staff/Reactivate/${staffId}`;

    const serverResponse = await api.put(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async updateNotifyByEmailOnMessageFlag(
    notifyByEmailOnMessage: boolean
  ): Promise<AxiosResponse<boolean>> {
    const url = `/Portal/Staff/UpdateNotifyByEmailOnMessageFlag`;

    const serverResponse = await api.put(url, {
      NotifyByEmailOnMessage: notifyByEmailOnMessage,
    });

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async updateDefaultAppointmentUrl(
    defaultAppointmentUrl: string | null
  ): Promise<AxiosResponse<void>> {
    const url = `/Portal/Staff/UpdateDefaultAppointmentUrl`;

    const serverResponse = await api.put(url, {
      DefaultAppointmentUrl: defaultAppointmentUrl,
    });

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async updateHcpAppointmentUrl(
    hcpAppointmentUrl: string | null
  ): Promise<AxiosResponse<void>> {
    const url = `/Portal/Staff/UpdateHcpAppointmentUrl`;

    const serverResponse = await api.put(url, {
      HcpAppointmentUrl: hcpAppointmentUrl,
    });

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async getTaggableHcpsForPatient(
    patientId: number
  ): Promise<AxiosResponse<ITaggableHcp[]>> {
    const url = `/Portal/Staff/GetTaggableHcpsForPatient`;
    return api.get<ITaggableHcp[]>(url, { params: { patientId } });
  },
};
